$(function(e) {
    const movingBackgroundsA = document.querySelectorAll(".section.bg-mv-wavy-a > .movingBg");
    const movingBackgroundsB = document.querySelectorAll(".section.bg-mv-wavy-b > .movingBg");
    let inViews = [];
    let offsets = Array(movingBackgroundsA.length + movingBackgroundsB.length).fill(0);

    const MIN_OFFSET_A = -50;
    const MAX_OFFSET_A = -5;
    const MIN_OFFSET_B = -260;
    const MAX_OFFSET_B = 0;

    const SPEED_MODIFIER_A = 0.4; // Speed modifier for A
    const SPEED_MODIFIER_B = 0.4; // Speed modifier for B

    movingBackgroundsA.forEach((movingBg) => {
        inViews.push(movingBg.parentElement.getBoundingClientRect().top - window.innerHeight <= -240);
    });
    movingBackgroundsB.forEach((movingBg) => {
        inViews.push(movingBg.parentElement.getBoundingClientRect().top - window.innerHeight <= -240);
    });
    let scrollTop;

    window.addEventListener("scroll", () => {
        let st = window.scrollY || document.documentElement.scrollTop;
        inViews = [];
        movingBackgroundsA.forEach((movingBg) => {
            inViews.push(
                movingBg.parentElement.getBoundingClientRect().top - window.innerHeight <= -240 &&
                movingBg.parentElement.getBoundingClientRect().bottom -
                (movingBg.parentElement.getBoundingClientRect().height) / 3 >
                0
            );
        });
        movingBackgroundsB.forEach((movingBg) => {
            inViews.push(
                movingBg.parentElement.getBoundingClientRect().top - window.innerHeight <= -240 &&
                movingBg.parentElement.getBoundingClientRect().bottom -
                (movingBg.parentElement.getBoundingClientRect().height * 2) / 3 >
                0
            );
        });
        for (let i = 0; i < movingBackgroundsA.length; i++) {
            if (inViews[i]) {
                if (st > scrollTop) {
                    offsets[i] -= SPEED_MODIFIER_A;
                    offsets[i] = offsets[i] < MIN_OFFSET_A ? MIN_OFFSET_A : offsets[i];
                    movingBackgroundsA[i].style.top = `${offsets[i]}%`;
                } else {
                    offsets[i] += SPEED_MODIFIER_A;
                    offsets[i] = offsets[i] > MAX_OFFSET_A ? MAX_OFFSET_A : offsets[i];
                    movingBackgroundsA[i].style.top = `${offsets[i]}%`;
                }
            } else {
                if (movingBackgroundsA[i].parentElement.getBoundingClientRect().top > window.innerHeight) {
                    movingBackgroundsA[i].style.top = `${MAX_OFFSET_A}%`;
                    offsets[i] = MAX_OFFSET_A;
                }
                if (movingBackgroundsA[i].parentElement.getBoundingClientRect().bottom < 0) {
                    movingBackgroundsA[i].style.top = `${MIN_OFFSET_A}%`;
                    offsets[i] = MIN_OFFSET_A;
                }
            }
        }
        for (let i = 0; i < movingBackgroundsB.length; i++) {
            let indexAdjusted = i + movingBackgroundsA.length;
            if (inViews[indexAdjusted]) {
                if (st > scrollTop) {
                    offsets[indexAdjusted] += 6.75 * SPEED_MODIFIER_B;
                    offsets[indexAdjusted] = offsets[indexAdjusted] > MAX_OFFSET_B ? MAX_OFFSET_B : offsets[indexAdjusted];
                    movingBackgroundsB[i].style.top = `${offsets[indexAdjusted]}px`;
                } else {
                    offsets[indexAdjusted] -= 6.75 * SPEED_MODIFIER_B;
                    offsets[indexAdjusted] = offsets[indexAdjusted] < MIN_OFFSET_B ? MIN_OFFSET_B : offsets[indexAdjusted];
                    movingBackgroundsB[i].style.top = `${offsets[indexAdjusted]}px`;
                }
            } else {
                if (movingBackgroundsB[i].parentElement.getBoundingClientRect().top > window.innerHeight) {
                    movingBackgroundsB[i].style.top = `${MIN_OFFSET_B}px`;
                    offsets[indexAdjusted] = MIN_OFFSET_B;
                }
                if (movingBackgroundsB[i].parentElement.getBoundingClientRect().bottom < 0) {
                    movingBackgroundsB[i].style.top = `${MAX_OFFSET_B}px`;
                    offsets[indexAdjusted] = MAX_OFFSET_B;
                }
            }
        }
        scrollTop = st <= 0 ? 0 : st;
    }, { passive: true });
});
